import React from 'react';

import CallToActionDesignMock from './components/CallToActionDesignMock';
import Features from './components/Features';
import HeadTitle from './components/HeadTitle';
import WhatIsMocky from './components/WhatIsMocky';

const Home = () => (
  <>
    <HeadTitle />
    <WhatIsMocky />
    <CallToActionDesignMock />
    <Features />
  </>
);
export default Home;
